<template>
  <div style="padding:50px; margin:0 auto; text-align: center;">
    <h1>提示信息</h1>
    <div>{{ message }}</div>
  </div>
</template>

<script>
export default {
  name: 'CoreCommonMessage',
  data() {
    return {
      live: $$.module.data || {},
      page: {}
    };
  },
  computed: {
    message() {
      return this.live.message;
    }
  },
  mounted() {}
};
</script>
